import { render, staticRenderFns } from "./V2AppLogo.vue?vue&type=template&id=1bd90abf&scoped=true&"
import script from "./V2AppLogo.vue?vue&type=script&lang=js&"
export * from "./V2AppLogo.vue?vue&type=script&lang=js&"
import style0 from "./V2AppLogo.vue?vue&type=style&index=0&id=1bd90abf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd90abf",
  null
  
)

export default component.exports